module.exports = __webpack_public_path__ + "img/icon_password.0023877c.png";